/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcp_Demo_Tool_ConnectingInputs */

const en_mcp_demo_tool_connecting = /** @type {(inputs: Mcp_Demo_Tool_ConnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connecting`)
};

const es_mcp_demo_tool_connecting = /** @type {(inputs: Mcp_Demo_Tool_ConnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conectando`)
};

/**
* | output |
* | --- |
* | "Connecting" |
*
* @param {Mcp_Demo_Tool_ConnectingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mcp_demo_tool_connecting = /** @type {((inputs?: Mcp_Demo_Tool_ConnectingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Demo_Tool_ConnectingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mcp_demo_tool_connecting(inputs)
	return en_mcp_demo_tool_connecting(inputs)
});